import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import cx from "classnames";
import { ReactComponent as Spinner } from "assets/icons/spinner.svg";
import { Button } from "elements/Button/Button";
import { Loader } from "blocks/Loader/Loader";
import { SearchBarContainer } from "components/SearchBar/SearchBarContainer";
import { SidebarContainer } from "components/Sidebar/SidebarContainer";
import { SearchResultsContainer } from "components/SearchResults/SearchResultsContainer";
import { ReactComponent as Caret } from "assets/icons/caret.svg";
import { registerPageview }   from '../../gtm';
import "./SearchScreen.scss";

export const SearchScreen = props => {
  const defaultIndex = 2;
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex);
  const isMenuOpen = selectedIndex !== defaultIndex;

  const url = window.location.pathname + window.location.search;
  const title = props.pageTitle || props.defaultPageTitle;

  useEffect(() => {
    if (props.isInitialized) {
      registerPageview(url, title);
    }
  }, [url]);

  useEffect(() => {
    document.body.dataset.searchMenuOpen = isMenuOpen;

    if(!isMenuOpen){
      window.scrollTo({top: 0, behavior: "smooth"});
    }
  }, [isMenuOpen])

  const showResults = () => {
    setSelectedIndex(defaultIndex);
  };

  const selectTab = (index, lastIndex) => {
    const selectedIndex = index !== lastIndex ? index : defaultIndex;
    setSelectedIndex(selectedIndex);
  };

  const renderToggleButton = text => (
    <Button
      text={text}
      onClick={showResults}
      render={() => (
        <Fragment>
          <span className="button__text">{text}</span>
          {props.isLoading && (
            <div className="button__icon">
              <Spinner />
            </div>
          )}
        </Fragment>
      )}
    />
  );

  const classNames = cx([
    "search-screen",
    { "search-screen--initializing": !props.isInitialized },
  ]);

  const renderContent = () => {
    if(!props.isInitialized){
      return <Loader />;
    }

    return (
      <Tabs
        className="grid grid-noGutter"
          forceRenderTabPanel={true}
          defaultFocus={true}
          selectedIndex={selectedIndex}
          onSelect={selectTab}
          selectedTabClassName="is-selected"
        selectedTabPanelClassName="is-selected">
        <TabList className="col-12 sm-visible search-screen__tablist">
          <Tab className="search-screen__tab">
            {props.searchOptionsToggle} <Caret />
          </Tab>
          <Tab className="search-screen__tab">
            {props.filtersToggle} <Caret />
          </Tab>
          <Tab className="hidden" />
        </TabList>
        <TabPanel className="search-screen__tabpanel col-12_sm-12">
          <SearchBarContainer />
          <div className="search-screen__tabpanel__toggle search-screen__tabpanel__toggle--fixed sm-visible">
            {renderToggleButton(props.primaryFilterCTA)}
          </div>
        </TabPanel>
        <TabPanel className="search-screen__tabpanel col-2_md-3_sm-12">
          <SidebarContainer />
          <div className="search-screen__tabpanel__toggle search-screen__tabpanel__toggle--fixed sm-visible">
            {renderToggleButton(props.secondaryFilterCTA)}
          </div>
        </TabPanel>
        <TabPanel className="search-screen__tabpanel col-10_md-9_sm-12">
          <SearchResultsContainer />
        </TabPanel>
      </Tabs>
    );
  };

  return (
    <div className={classNames}>
      {renderContent()}
    </div>
  );
};

SearchScreen.propTypes = {
  isInitialized: PropTypes.bool.isRequired,
  searchOptionsToggle: PropTypes.string,
  filtersToggle: PropTypes.string,
  primaryFilterCTA: PropTypes.string,
  secondaryFilterCTA: PropTypes.string,
};